import React from "react";
import { IoClose, IoShieldCheckmark, IoShieldOutline } from "react-icons/io5";

const SalesRepAccessModal = ({ isOpen, onClose, salesRepData, onToggle, isLoading }) => {
  if (!isOpen) return null;

  const hasAccess = salesRepData?.access_granted;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-teal-500 to-blue-500 p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white"
          >
            <IoClose size={24} />
          </button>
          <div className="flex items-center gap-3">
            {hasAccess ? (
              <IoShieldCheckmark className="text-white text-4xl" />
            ) : (
              <IoShieldOutline className="text-white text-4xl" />
            )}
            <div>
              <h2 className="text-2xl font-bold text-white">Sales Rep Access</h2>
              <p className="text-teal-100 text-sm mt-1">Manage dashboard permissions</p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          {!salesRepData?.has_sales_rep ? (
            <div className="text-center py-8">
              <IoShieldOutline className="text-gray-400 text-5xl mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-2">
                No Sales Representative
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                You don't have a sales representative assigned yet.
              </p>
            </div>
          ) : (
            <>
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 mb-2">
                  Your Sales Representative
                </h3>
                <p className="text-lg font-bold text-gray-800 dark:text-gray-200">
                  {salesRepData.sales_rep_name}
                </p>
                {salesRepData.sales_rep_email && (
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    {salesRepData.sales_rep_email}
                  </p>
                )}
              </div>

              <div className={`rounded-xl p-4 mb-6 ${
                hasAccess 
                  ? 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800' 
                  : 'bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800'
              }`}>
                <h4 className={`font-semibold mb-2 ${
                  hasAccess ? 'text-green-800 dark:text-green-300' : 'text-amber-800 dark:text-amber-300'
                }`}>
                  {hasAccess ? '✓ Access Granted' : '⚠ Access Not Granted'}
                </h4>
                <p className={`text-sm ${
                  hasAccess ? 'text-green-700 dark:text-green-300' : 'text-amber-700 dark:text-amber-300'
                }`}>
                  {hasAccess 
                    ? 'Your sales rep can view your dashboard.' 
                    : 'Grant access to let your sales rep help you.'}
                </p>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={onClose}
                  className="flex-1 px-4 py-3 text-sm font-semibold text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-600"
                  disabled={isLoading}
                >
                  Close
                </button>
                <button
                  onClick={onToggle}
                  disabled={isLoading}
                  className={`flex-1 px-4 py-3 text-sm font-semibold text-white rounded-xl transition-all disabled:opacity-50 ${
                    hasAccess
                      ? 'bg-red-500 hover:bg-red-600'
                      : 'bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600'
                  }`}
                >
                  {isLoading ? 'Please wait...' : hasAccess ? 'Revoke Access' : 'Grant Access'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesRepAccessModal;